/**
 * Given items ordered oldest-first, pick the prefix (oldest → newest) whose
 * total is closest to targetAmount. A prefix, not an arbitrary subset, because
 * the pool (the safe, free cash receipts) is meant to be drained in order.
 */
export function selectPrefixForTarget<T>(
  itemsOldestFirst: T[],
  amountOf: (item: T) => number,
  targetAmount: number,
): T[] {
  let bestCount = 0;
  let bestDiff = Math.abs(targetAmount);
  let running = 0;
  for (let i = 0; i < itemsOldestFirst.length; i++) {
    running += Number(amountOf(itemsOldestFirst[i]!));
    const diff = Math.abs(running - targetAmount);
    if (diff < bestDiff) {
      bestDiff = diff;
      bestCount = i + 1;
    }
  }
  return itemsOldestFirst.slice(0, bestCount);
}

/** Safe envelopes, ordered oldest-first, closest to targetAmount. */
export function selectEnvelopesForTarget<T extends { amount_to_safe: number }>(
  envelopesOldestFirst: T[],
  targetAmount: number,
): T[] {
  return selectPrefixForTarget(envelopesOldestFirst, (e) => e.amount_to_safe, targetAmount);
}
